import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, withModifiers as _withModifiers, isRef as _isRef } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "contentContainer centerContent" }
const _hoisted_3 = { class: "contentColumn" }
const _hoisted_4 = { class: "left-section" }
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "center-section" }
const _hoisted_7 = ["src"]
const _hoisted_8 = { class: "right-section" }
const _hoisted_9 = { class: "loginComp" }
const _hoisted_10 = { class: "login-head" }
const _hoisted_11 = { class: "login-elem" }
const _hoisted_12 = ["src"]
const _hoisted_13 = { key: 0 }
const _hoisted_14 = { class: "login-label" }
const _hoisted_15 = { class: "inputPanel" }
const _hoisted_16 = { class: "button-and-recover-panel" }
const _hoisted_17 = { class: "button-box" }
const _hoisted_18 = ["src"]
const _hoisted_19 = ["src"]
const _hoisted_20 = {
  key: 1,
  class: "loginError"
}
const _hoisted_21 = { class: "pointer footer-elem" }
const _hoisted_22 = { key: 1 }
const _hoisted_23 = { class: "login-label-password" }
const _hoisted_24 = { class: "autorization-elem-password" }
const _hoisted_25 = { class: "login-label-password-message" }
const _hoisted_26 = { class: "button-and-recover-panel" }
const _hoisted_27 = { class: "button-box" }
const _hoisted_28 = ["src"]
const _hoisted_29 = ["src"]
const _hoisted_30 = {
  key: 1,
  class: "loginError"
}
const _hoisted_31 = { class: "footer-elem-password" }
const _hoisted_32 = { key: 2 }
const _hoisted_33 = { class: "login-label-password" }
const _hoisted_34 = { class: "autorization-elem-password" }
const _hoisted_35 = { class: "recover-message-box" }
const _hoisted_36 = { class: "login-label-recover-password-message" }
const _hoisted_37 = { class: "login-label-recover-password-message" }
const _hoisted_38 = {
  class: "button-box",
  style: {"margin-top":"8px"}
}
const _hoisted_39 = ["src"]
const _hoisted_40 = ["src"]
const _hoisted_41 = {
  key: 1,
  class: "loginError"
}
const _hoisted_42 = { class: "footer-elem-password" }
const _hoisted_43 = { key: 3 }
const _hoisted_44 = { class: "login-label-access" }
const _hoisted_45 = { class: "autorization-elem-password" }
const _hoisted_46 = { class: "recover-message-box" }
const _hoisted_47 = { class: "login-label-recover-password-message" }
const _hoisted_48 = { class: "button-box" }
const _hoisted_49 = ["src"]
const _hoisted_50 = ["src"]
const _hoisted_51 = {
  key: 1,
  class: "loginError"
}
const _hoisted_52 = { class: "footer-elem-password" }
const _hoisted_53 = { key: 4 }
const _hoisted_54 = { class: "login-label-access" }
const _hoisted_55 = { class: "autorization-elem-password" }
const _hoisted_56 = { class: "login-label-recover-password-message" }
const _hoisted_57 = { class: "button-box" }
const _hoisted_58 = ["src"]
const _hoisted_59 = ["src", "disabled"]
const _hoisted_60 = {
  key: 1,
  class: "loginLeftPanelElement loginError"
}
const _hoisted_61 = { class: "footer-elem-password" }

import { ref, computed} from "vue";
import { i18n } from "@/i18n";
import { LoginAsker, LoginMail, RecoverAsker } from "@/models/login/login";
import { authStore } from "@/store/login";
import { trim } from "lodash";
import { useRoute } from "vue-router";

import LoginInput from "@/components/login/LoginInput.vue";
import PasswordInput from "@/components/login/PasswordInput.vue";
import LangDropdown from "@/components/login/LangDropdown.vue";
// import LoginTextarea from '@/components/login/LoginTextarea.vue';
import AppCustomTextarea from "@/components/ui-kit/textarea/AppCustomTextarea.vue";
import LoginButtonLink from "@/components/login/LoginButtonLink.vue";
import AppButton from "@/components/ui-kit/button/AppButton.vue";
import AppLoader from "@/components/ui-kit/loader/AppLoader.vue";

import "@/styles/inputs.scss";

//icons

type LoginLanguageCode = "ru" | "en" | "vn";


export default /*@__PURE__*/_defineComponent({
  __name: 'LoginPage',
  setup(__props) {

const iconMostaLabelRu = new URL(
  "@/assets/image/mosta-label-ru.svg",
  import.meta.url,
).href;
const iconMostaLabelEn = new URL(
  "@/assets/image/mosta-label-en.svg",
  import.meta.url,
).href;
const iconMostaMainLabelRu = new URL(
  "@/assets/image/main-back-mosta-logo-ru.svg",
  import.meta.url,
).href;
const iconMostaMainLabelEn = new URL(
  "@/assets/image/main-back-mosta-logo-en.svg",
  import.meta.url,
).href;
const iconLoginCentralLine = new URL(
  "@/assets/image/login-central-line.svg",
  import.meta.url,
).href;
const iconButtonLeftLine = new URL(
  "@/assets/image/login-left-line.svg",
  import.meta.url,
).href;
const iconButtonRightLine = new URL(
  "@/assets/image/login-right-line.svg",
  import.meta.url,
).href;

const authstore = authStore();
const route = useRoute();

//password

const isRecoverButtonDisabled = computed(() => {
  if (!login.value.Mail) {
    return true;
  }

  if (!showEmailValidateIcons.value) {
    return true;
  }

  if (isLoginLoading.value) {
    return true;
  }

  return false;
});

//login
const showEmailValidateIcons = computed(() => {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(login.value.Mail);
});

const isLoginButtonDisabled = computed(() => {
  const hasMail = Boolean(login.value.Mail) || loginAutofilled.value;
  const hasPassword = Boolean(login.value.PassWord) || passwordAutofilled.value;

  if (!hasMail || !hasPassword) {
    return true;
  }

  if (login.value.Mail && !showEmailValidateIcons.value) {
    return true;
  }

  if (login.value.PassWord && login.value.PassWord.length < 6) {
    return true;
  }

  if (isLoginLoading.value) {
    return true;
  }

  return false;
});

const clearLoginError = () => {
  authstore.clearErrorMessage();
};

const isSendResponseDisabled = computed(() => {
  if (!trim(AuthorizationProblemMessage.value)) {
    return true;
  }

  if (isLoginLoading.value) {
    return true;
  }

  return false;
});

//lang dropdown

const languages = ref([
  {
    code: "ru",
    icon: new URL("@/assets/image/icon-lang-ru.svg", import.meta.url).href,
    label: iconMostaLabelRu,
    mainLabel: iconMostaMainLabelRu,
  },
  {
    code: "en",
    icon: new URL("@/assets/image/icon-lang-en.svg", import.meta.url).href,
    label: iconMostaLabelEn,
    mainLabel: iconMostaMainLabelEn,
  },
  {
    code: "vn",
    icon: new URL("@/assets/image/icon-lang-vn.svg", import.meta.url).href,
    label: iconMostaLabelEn,
    mainLabel: iconMostaMainLabelEn,
  },
]);

const loginLanguageValues: Record<LoginLanguageCode, number> = {
  ru: 0,
  en: 1,
  vn: 2,
};

let currentLanguage = ref<LoginLanguageCode>("ru");

const currentMostaLabelLangIcon = computed(() => {
  const lang = languages.value.find(
    (lang) => lang.code === currentLanguage.value,
  );
  return lang ? lang.label : languages.value[0].label;
});

const currentMainMostaLabelLangIcon = computed(() => {
  const lang = languages.value.find(
    (lang) => lang.code === currentLanguage.value,
  );
  return lang ? lang.mainLabel : languages.value[0].mainLabel;
});

const selectLanguage = (lang: LoginLanguageCode) => {
  currentLanguage.value = lang;
  const locale = lang === "vn" ? "vi" : lang;
  // @ts-ignore vue-i18n legacy locale type
  i18n.global.locale = locale;
};

//lang

const initialLocale =
  currentLanguage.value === "vn" ? "vi" : currentLanguage.value;
// @ts-ignore vue-i18n legacy locale type
i18n.global.locale = initialLocale;

const selectedLoginLanguage = () => loginLanguageValues[currentLanguage.value];

const param = process.env.VUE_APP_API_URL + "/";

let AuthorizationProblemMessage = ref("");

let accessRecover = ref(false);
let passwordRecover = ref(false);
let loginPage = ref(true);
let accessRecoverResult = ref(false);
let passwordRecoverResult = ref(false);
const isLoginLoading = computed(() => authstore.loginIsLoading);
const loginErrorText = computed(() => authstore.ErrorMessage);
const statusCode = computed(() => authstore.statusCode);
const loginError = computed(() => Boolean(loginErrorText.value));

const login = ref<LoginMail>({
  Mail: "",
  PassWord: "",
  Id: 0,
});
const loginAutofilled = ref(false);
const passwordAutofilled = ref(false);

async function LoginInside() {
  const autofilledMail = (
    document.getElementById("login-input-elm") as HTMLInputElement | null
  )?.value;
  const autofilledPassword = (
    document.getElementById("password-input-elm") as HTMLInputElement | null
  )?.value;
  if (autofilledMail) login.value.Mail = autofilledMail;
  if (autofilledPassword) login.value.PassWord = autofilledPassword;

  let checker2 = new LoginAsker();
  checker2.Language = selectedLoginLanguage();
  checker2.Password = ReplaceBadThings(login.value.PassWord);
  checker2.Mail = ReplaceBadThings(login.value.Mail);
  checker2.ServerLink = param;

  const success = await authstore.LoginAuth(checker2);

  if (success) {
    const redirect = String(route.query.redirect ?? "");
    const target =
      redirect.startsWith("/") &&
      !redirect.startsWith("//") &&
      redirect !== "/login"
        ? redirect
        : "/main";

    window.location.assign(target);
  }
}

async function recoverPasswordInside() {
  let checker = new RecoverAsker();
  checker.Language = selectedLoginLanguage();
  checker.Value = ReplaceBadThings(login.value.Mail);

  const success = await authstore.recoverByEmail(checker);

  if (success) {
    accessRecover.value = false;
    passwordRecover.value = false;
    loginPage.value = false;
    accessRecoverResult.value = false;
    passwordRecoverResult.value = true;
  }
}

async function recoverAccessInside() {
  let checker = new RecoverAsker();
  checker.Language = selectedLoginLanguage();
  checker.Value = ReplaceBadThings(AuthorizationProblemMessage.value);

  const success = await authstore.recoverByName(checker);

  if (success) {
    accessRecover.value = false;
    passwordRecover.value = false;
    loginPage.value = false;
    accessRecoverResult.value = true;
    passwordRecoverResult.value = false;
  }
}

function ReplaceBadThings(str: string): string {
  return str != null
    ? str.replace(/\\/g, "\\\\").replace(/"/g, '\\"').replace(/'/g, "`")
    : "";
}

const showPasswordRecover = () => {
  accessRecover.value = false;
  passwordRecover.value = true;
  loginPage.value = false;
  accessRecoverResult.value = false;
  passwordRecoverResult.value = false;
  authstore.clearErrorMessage();
};

const showLoginPage = () => {
  accessRecover.value = false;
  passwordRecover.value = false;
  loginPage.value = true;
  accessRecoverResult.value = false;
  passwordRecoverResult.value = false;
  authstore.clearErrorMessage();
};

const showAccessRecover = () => {
  accessRecover.value = true;
  passwordRecover.value = false;
  loginPage.value = false;
  accessRecoverResult.value = false;
  passwordRecoverResult.value = false;

  authstore.clearErrorMessage();
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[6] || (_cache[6] = _createElementVNode("div", { class: "background-layer" }, null, -1)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("img", {
            src: currentMainMostaLabelLangIcon.value,
            class: "back-login-image"
          }, null, 8, _hoisted_5)
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("img", {
            src: _unref(iconLoginCentralLine),
            width: "16",
            height: "16",
            class: "central-login-line-image"
          }, null, 8, _hoisted_7)
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("div", _hoisted_11, [
                _createVNode(LangDropdown, {
                  languages: languages.value,
                  "current-language": _unref(currentLanguage),
                  onLanguageChange: selectLanguage
                }, null, 8, ["languages", "current-language"])
              ]),
              _createElementVNode("img", {
                src: currentMostaLabelLangIcon.value,
                width: "16",
                height: "16",
                class: "mosta-label"
              }, null, 8, _hoisted_12)
            ]),
            (_unref(loginPage))
              ? (_openBlock(), _createElementBlock("span", _hoisted_13, [
                  _createElementVNode("label", _hoisted_14, _toDisplayString(_ctx.$t("Login.EnterMessage")), 1),
                  _createElementVNode("form", {
                    class: "autorizationElem",
                    onSubmit: _withModifiers(LoginInside, ["prevent"])
                  }, [
                    _createElementVNode("div", _hoisted_15, [
                      _createVNode(LoginInput, {
                        modelValue: login.value.Mail,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((login.value.Mail) = $event)),
                        error: loginError.value,
                        onClearError: clearLoginError,
                        onAutofillState: _cache[1] || (_cache[1] = ($event: any) => (loginAutofilled.value = $event))
                      }, null, 8, ["modelValue", "error"]),
                      _createVNode(PasswordInput, {
                        modelValue: login.value.PassWord,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((login.value.PassWord) = $event)),
                        error: loginError.value,
                        onClearError: clearLoginError,
                        onAutofillState: _cache[3] || (_cache[3] = ($event: any) => (passwordAutofilled.value = $event))
                      }, null, 8, ["modelValue", "error"])
                    ]),
                    _createElementVNode("div", _hoisted_16, [
                      _createElementVNode("div", _hoisted_17, [
                        _createElementVNode("img", {
                          src: _unref(iconButtonLeftLine),
                          width: "16",
                          height: "16",
                          class: "button-line"
                        }, null, 8, _hoisted_18),
                        _createVNode(AppButton, {
                          label: _ctx.$t('Login.Login'),
                          disabled: isLoginButtonDisabled.value,
                          width: "136px",
                          type: "primary"
                        }, null, 8, ["label", "disabled"]),
                        _createElementVNode("img", {
                          src: _unref(iconButtonRightLine),
                          width: "16",
                          height: "16",
                          class: "button-line"
                        }, null, 8, _hoisted_19)
                      ]),
                      _createElementVNode("div", {
                        class: "loginClickableText",
                        onClick: showPasswordRecover
                      }, _toDisplayString(_ctx.$t("Login.ForgotPassword")), 1)
                    ]),
                    (isLoginLoading.value)
                      ? (_openBlock(), _createBlock(AppLoader, { key: 0 }))
                      : _createCommentVNode("", true),
                    (loginErrorText.value)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_20, _toDisplayString(statusCode.value != 500
                      ? _ctx.$t("Login.LoginError")
                      : _ctx.$t("Login.ServerError")), 1))
                      : _createCommentVNode("", true)
                  ], 32),
                  _createElementVNode("div", _hoisted_21, [
                    _createVNode(LoginButtonLink, {
                      label: _ctx.$t('Login.Unsigned'),
                      "icon-name": "info-circle-outline",
                      "tooltip-text": _ctx.$t('Login.UnsignedHintMessage'),
                      "show-tooltip-on-hover": true
                    }, null, 8, ["label", "tooltip-text"])
                  ])
                ]))
              : _createCommentVNode("", true),
            (_unref(passwordRecover))
              ? (_openBlock(), _createElementBlock("span", _hoisted_22, [
                  _createElementVNode("label", _hoisted_23, _toDisplayString(_ctx.$t("Login.PasswordRecovering")), 1),
                  _createElementVNode("div", _hoisted_24, [
                    _createElementVNode("label", _hoisted_25, _toDisplayString(_ctx.$t("Login.InputUsedEmail")), 1),
                    _createVNode(LoginInput, {
                      modelValue: login.value.Mail,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((login.value.Mail) = $event)),
                      error: loginError.value,
                      onClearError: clearLoginError
                    }, null, 8, ["modelValue", "error"]),
                    _createElementVNode("div", _hoisted_26, [
                      _createElementVNode("div", _hoisted_27, [
                        _createElementVNode("img", {
                          src: _unref(iconButtonLeftLine),
                          width: "16",
                          height: "16",
                          class: "button-line"
                        }, null, 8, _hoisted_28),
                        _createVNode(AppButton, {
                          label: _ctx.$t('Login.PasswordRecoveringButton'),
                          disabled: isRecoverButtonDisabled.value,
                          onClick: recoverPasswordInside,
                          width: "175px",
                          type: "primary"
                        }, null, 8, ["label", "disabled"]),
                        _createElementVNode("img", {
                          src: _unref(iconButtonRightLine),
                          width: "16",
                          height: "16",
                          class: "button-line"
                        }, null, 8, _hoisted_29)
                      ]),
                      _createElementVNode("div", {
                        class: "loginClickableText",
                        onClick: showAccessRecover
                      }, _toDisplayString(_ctx.$t("Login.AuthorizationProblem")), 1)
                    ]),
                    (isLoginLoading.value)
                      ? (_openBlock(), _createBlock(AppLoader, { key: 0 }))
                      : _createCommentVNode("", true),
                    (loginErrorText.value)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_30, _toDisplayString(statusCode.value != 500
                      ? _ctx.$t("Login.UserNotFoundError")
                      : _ctx.$t("Login.ServerError")), 1))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_31, [
                    _createVNode(AppButton, {
                      label: _ctx.$t('Login.Back'),
                      onClick: showLoginPage,
                      type: "link",
                      width: "111px"
                    }, null, 8, ["label"])
                  ])
                ]))
              : _createCommentVNode("", true),
            (_unref(passwordRecoverResult))
              ? (_openBlock(), _createElementBlock("span", _hoisted_32, [
                  _createElementVNode("label", _hoisted_33, _toDisplayString(_ctx.$t("Login.PasswordRecovering")), 1),
                  _createElementVNode("div", _hoisted_34, [
                    _createElementVNode("div", _hoisted_35, [
                      _createElementVNode("label", _hoisted_36, _toDisplayString(_ctx.$t("Login.PasswordSentToMail")), 1),
                      _createElementVNode("label", _hoisted_37, _toDisplayString(_ctx.$t("Login.RepeatResponsePasswordMessage")), 1)
                    ]),
                    _createElementVNode("div", _hoisted_38, [
                      _createElementVNode("img", {
                        src: _unref(iconButtonLeftLine),
                        width: "16",
                        height: "16",
                        class: "button-line"
                      }, null, 8, _hoisted_39),
                      _createVNode(AppButton, {
                        label: _ctx.$t('Login.SendAgain'),
                        onClick: recoverPasswordInside,
                        style: {"width":"153px !important"},
                        disabled: isLoginLoading.value,
                        type: "primary"
                      }, null, 8, ["label", "disabled"]),
                      _createElementVNode("img", {
                        src: _unref(iconButtonRightLine),
                        width: "16",
                        height: "16",
                        class: "button-line",
                        type: "primary"
                      }, null, 8, _hoisted_40)
                    ]),
                    (isLoginLoading.value)
                      ? (_openBlock(), _createBlock(AppLoader, { key: 0 }))
                      : _createCommentVNode("", true),
                    (loginErrorText.value)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_41, _toDisplayString(statusCode.value != 500
                      ? _ctx.$t("Login.UserNotFoundError")
                      : _ctx.$t("Login.ServerError")), 1))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_42, [
                    _createVNode(AppButton, {
                      label: _ctx.$t('Login.Back'),
                      onClick: showLoginPage,
                      type: "link"
                    }, null, 8, ["label"])
                  ])
                ]))
              : _createCommentVNode("", true),
            (_unref(accessRecover))
              ? (_openBlock(), _createElementBlock("span", _hoisted_43, [
                  _createElementVNode("label", _hoisted_44, _toDisplayString(_ctx.$t("Login.RestoringAccessToAccount")), 1),
                  _createElementVNode("div", _hoisted_45, [
                    _createElementVNode("div", _hoisted_46, [
                      _createElementVNode("label", _hoisted_47, _toDisplayString(_ctx.$t("Login.SendContactDataMessage")), 1)
                    ]),
                    _createVNode(AppCustomTextarea, {
                      modelValue: _unref(AuthorizationProblemMessage),
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_isRef(AuthorizationProblemMessage) ? (AuthorizationProblemMessage).value = $event : AuthorizationProblemMessage = $event)),
                      placeholder: _ctx.$t('Login.DescribeProblem'),
                      "min-height": 66,
                      "max-height": 66,
                      "max-rows": 3
                    }, null, 8, ["modelValue", "placeholder"]),
                    _createElementVNode("div", _hoisted_48, [
                      _createElementVNode("img", {
                        src: _unref(iconButtonLeftLine),
                        width: "16",
                        height: "16",
                        class: "button-line"
                      }, null, 8, _hoisted_49),
                      _createVNode(AppButton, {
                        label: _ctx.$t('Login.SendResponce'),
                        disabled: isSendResponseDisabled.value,
                        onClick: recoverAccessInside,
                        type: "primary"
                      }, null, 8, ["label", "disabled"]),
                      _createElementVNode("img", {
                        src: _unref(iconButtonRightLine),
                        width: "14",
                        height: "16",
                        class: "button-line"
                      }, null, 8, _hoisted_50)
                    ]),
                    (isLoginLoading.value)
                      ? (_openBlock(), _createBlock(AppLoader, { key: 0 }))
                      : _createCommentVNode("", true),
                    (loginErrorText.value)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_51, _toDisplayString(statusCode.value != 500 ? loginErrorText.value : _ctx.$t("Login.ServerError")), 1))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_52, [
                    _createVNode(AppButton, {
                      label: _ctx.$t('Login.Back'),
                      onClick: showLoginPage,
                      type: "link"
                    }, null, 8, ["label"])
                  ])
                ]))
              : _createCommentVNode("", true),
            (_unref(accessRecoverResult))
              ? (_openBlock(), _createElementBlock("span", _hoisted_53, [
                  _createElementVNode("label", _hoisted_54, _toDisplayString(_ctx.$t("Login.RestoringAccessToAccount")), 1),
                  _createElementVNode("div", _hoisted_55, [
                    _createElementVNode("label", _hoisted_56, _toDisplayString(_ctx.$t("Login.LoginProblemNotificationDescription")), 1),
                    _createElementVNode("div", _hoisted_57, [
                      _createElementVNode("img", {
                        src: _unref(iconButtonLeftLine),
                        width: "16",
                        height: "16",
                        class: "button-line"
                      }, null, 8, _hoisted_58),
                      _createVNode(AppButton, {
                        label: _ctx.$t('Login.SendAgain'),
                        onClick: recoverAccessInside,
                        type: "primary"
                      }, null, 8, ["label"]),
                      _createElementVNode("img", {
                        src: _unref(iconButtonRightLine),
                        width: "16",
                        height: "16",
                        class: "button-line",
                        disabled: isLoginLoading.value
                      }, null, 8, _hoisted_59)
                    ]),
                    (isLoginLoading.value)
                      ? (_openBlock(), _createBlock(AppLoader, { key: 0 }))
                      : _createCommentVNode("", true),
                    (loginErrorText.value)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_60, _toDisplayString(statusCode.value != 500 ? loginErrorText.value : _ctx.$t("Login.ServerError")), 1))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_61, [
                    _createVNode(AppButton, {
                      label: _ctx.$t('Login.Back'),
                      onClick: showLoginPage,
                      type: "link"
                    }, null, 8, ["label"])
                  ])
                ]))
              : _createCommentVNode("", true)
          ])
        ])
      ])
    ])
  ]))
}
}

})